import { InjectionToken } from '@angular/core';

export const LOCAL_STORAGE = new InjectionToken<Storage>('This token provides browser local storage', {
  providedIn: 'root',
  factory: (): Storage => localStorage,
});
